import React from 'react';
import { useRequestFormsForManagerQuery } from '../../../__generated__/graphql';
import { RequestForm } from '../RequestForm';
import { RequestFormProps } from '../RequestForm/types';

export const ManagerRequestForm: React.FC<RequestFormProps> = (props) => {
  const { data, loading } = useRequestFormsForManagerQuery({
    skip: !props.show,
  });

  return (
    <RequestForm
      {...props}
      requestForms={data?.requestForms ?? []}
      employees={data?.manager?.employees ?? []}
      loading={loading}
    />
  );
};
